const resources = {
    new: 'NEW',
    beautyChallenges: 'Beauty Insider Challenges: Earn points when you complete tasks'
};

module.exports = function getResource(label) {
    return resources[label];
};
